import React from "react";
import {
  Link,
  useLocation,
} from "react-router-dom";
import logo from "../../Images/statix tradinglogo.png";

import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Footer = () => {

  const location = useLocation();

  // Scroll Top
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer
      style={{
        background: "#0f172a",
        color: "#fff",
        padding: "50px 20px 20px",
        marginTop: "60px",
      }}
    >

      <div
        style={{
          maxWidth: "1200px",
          margin: "auto",
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit, minmax(220px, 1fr))",
          gap: "30px",
        }}
      >

        {/* Logo Section */}
        <div>

          <h2
            style={{
              color: "#22c55e",
              marginBottom: "15px",
            }}
          >
            Statix Trading
          </h2>

          <p
            style={{
              color: "#cbd5e1",
              lineHeight: "1.8",
              fontSize: "15px",
            }}
          >
            Smart trading platform with secure
            investments, live analytics,
            and professional support.
          </p>

        </div>

        {/* Quick Links */}
        <div>

          <h3 style={{ marginBottom: "15px" }}>
            Quick Links
          </h3>

          <ul
            style={{
              listStyle: "none",
              padding: 0,
              lineHeight: "2.3",
            }}
          >

            <li>
              <Link
                to="/"
                onClick={scrollTop}
                style={{
                  ...linkStyle,
                  color:
                    location.pathname === "/"
                      ? "#22c55e"
                      : "#cbd5e1",
                }}
              >
                Home
              </Link>
            </li>

            <li>
              <Link
                to="/about"
                onClick={scrollTop}
                style={{
                  ...linkStyle,
                  color:
                    location.pathname ===
                    "/about"
                      ? "#22c55e"
                      : "#cbd5e1",
                }}
              >
                About Us
              </Link>
            </li>

            <li>
              <Link
                to="/contact"
                onClick={scrollTop}
                style={{
                  ...linkStyle,
                  color:
                    location.pathname ===
                    "/contact"
                      ? "#22c55e"
                      : "#cbd5e1",
                }}
              >
                Contact Us
              </Link>
            </li>

            <li>
              <Link
                to="/privacy-policy"
                onClick={scrollTop}
                style={{
                  ...linkStyle,
                  color:
                    location.pathname ===
                    "/privacy-policy"
                      ? "#22c55e"
                      : "#cbd5e1",
                }}
              >
                Privacy Policy
              </Link>
            </li>

          </ul>

        </div>

        {/* Contact Info */}
        <div>

          <h3 style={{ marginBottom: "15px" }}>
            Contact Info
          </h3>

          <p style={contactStyle}>
            <FaEnvelope />
            support@tradepro.com
          </p>

          <p style={contactStyle}>
            <FaPhoneAlt />
            +91 98765 43210
          </p>

          <p style={contactStyle}>
            <FaMapMarkerAlt />
            Delhi, India
          </p>

        </div>

        {/* Social Media */}
        <div>

          <h3 style={{ marginBottom: "15px" }}>
            Follow Us
          </h3>

          <div
            style={{
              display: "flex",
              gap: "15px",
              marginTop: "10px",
            }}
          >

            <a href="#" style={socialStyle}>
              <FaFacebookF />
            </a>

            <a href="#" style={socialStyle}>
              <FaInstagram />
            </a>

            <a href="#" style={socialStyle}>
              <FaTwitter />
            </a>

            <a href="#" style={socialStyle}>
              <FaLinkedinIn />
            </a>

          </div>

        </div>

      </div>

      {/* Bottom Footer */}
      <div
        style={{
          borderTop: "1px solid #334155",
          marginTop: "40px",
          paddingTop: "20px",
          textAlign: "center",
          color: "#94a3b8",
          fontSize: "14px",
        }}
      >
        © 2026 Statix Trading.
        All Rights Reserved.
      </div>

    </footer>
  );
};

const linkStyle = {
  textDecoration: "none",
  fontSize: "15px",
  transition: "0.3s",
};

const contactStyle = {
  color: "#cbd5e1",
  display: "flex",
  alignItems: "center",
  gap: "10px",
  marginBottom: "12px",
  fontSize: "15px",
};

const socialStyle = {
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  background: "#1e293b",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  fontSize: "16px",
  transition: "0.3s",
};

export default Footer;